module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Pixels.fd32b4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Pixels.jpg
// module id = AUpu
// module chunks = 0